import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const WhatsAppButton = () => {
  const message = encodeURIComponent("Hallo, ich habe eine Anfrage über Ihre Website.");
  // Updated Phone Number
  const whatsappUrl = `https://wa.me/491605074395?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-50 flex items-center justify-center group"
      aria-label="Kontakt per WhatsApp"
    >
      <SafeIcon icon={FiIcons.FiMessageCircle} className="h-8 w-8" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs group-hover:ml-3 transition-all duration-300 ease-in-out font-medium">
        WhatsApp Chat
      </span>
    </a>
  );
};

export default WhatsAppButton;